import { BatchDTO } from "../dto/BatchesDTO";
import { BooksDTO } from "../dto/BooksDTO";
import { FetchAuth } from "../utils/FetchAuthUtil";

export interface TransactionItem {
    book: BooksDTO
    quantity: number;
    purchasedPrice: number;
    batchId:BatchDTO
}

export interface Transaction {
    _id: string;
    userId: {
        fullname: string;
        email: string;
    };
    items: TransactionItem[];
    totalAmount: number;
    orderDate: string;
    status: string;
}

export interface TransactionsResponse { 
    message: string,
    data: {
        orders: Transaction[];
        total: number;
    };
}

const endpoint = process.env.REACT_APP_API_ENDPOINT;

export class TransactionsService {
    public static getTransactions = async (
        page: number,
        limit: number,
        searchTerm: string,
        sortBy?: string | null,
        sortOrder?: 'asc' | 'desc'
    ): Promise<TransactionsResponse> => {
        try {
            const params = new URLSearchParams({
                page: String(page),
                limit: String(limit),
                ...(searchTerm && { search: searchTerm }),
                ...(sortBy && { sortBy }),
                ...(sortOrder && { sortOrder })
            });

            const resp = await FetchAuth(`${endpoint}/order/getAll?${params.toString()}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const data = await resp.json();
            return data;
        } catch (error) {
            throw error;
        }
    };

    public static getFile = async (format: "excel" | "csv" | "pdf"): Promise<Blob> => {
        try {
            const resp = await FetchAuth(`${endpoint}/admin/exportTransactions?format=${format}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            return await resp.blob();
        } catch (error) {
            throw error;
        }
    };
} 